<template>
      <div class="page-container" v-if="currentNews">
    <h1 class="page-title">{{ currentNews.title }}</h1>
    <p style="text-align: right;">2016-09-12</p>
    <div class="content">
      <!-- 第一段内容 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="formatMarkdown(currentNews.content?.split('---')[0] || '')"></p>
        </div>
      </div>

      <!-- 第一张图片 -->
      <div class="content-section image-section">
        <div class="image-container">
          <img :src="currentNews.other?.picture1?.url">
          <p class="image-caption">{{ currentNews.other?.picture1?.caption }}</p>
        </div>
      </div>

      <!-- 第二段内容 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="currentNews.content?.split('---')[1] || ''"></p>
        </div>
      </div>


      <!-- 第三段内容 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="currentNews.content?.split('---')[2] || ''"></p>
        </div>
      </div>

    </div>
  </div>
  <div v-else class="page-container">
    <p>新闻内容未找到</p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useLangStore } from '../../../pinia/stores/lang';
import zhData from '../../../i18n/zh';
import enData from '../../../i18n/en';

const langStore = useLangStore();

// 获取新闻数据的方法
const currentNews = computed(() => {
  const translationData = langStore.currentLang.startsWith('zh') ? zhData : enData;
  const newsList = translationData.pages.news.company.news.list;
  // 通过ID查找新闻
  const newsItem = newsList.find((news: any) => news.id === 'ascguoji');
  return newsItem || {};
});

// 处理Markdown格式（**文本**变为加粗）
const formatMarkdown = (text: string) => {
  if (!text) return '';
  return text.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
};
</script>

<style scoped lang="scss">


.page-title {
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 20px;
}

.content-section {
  margin-bottom: 30px;
}

.text-block {
  line-height: 1.6;
  
  p {
    margin-bottom: 15px;
  }
}

.image-section {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.image-container {
  margin-bottom: 20px;
  max-width: 100%;
  text-align: center;
  
  img {
    max-width: 100%;
    border-radius: 4px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
}

.image-caption {
  margin-top: 8px;
  text-align: center;
  font-size: 14px;
  color: #666;
}
</style> 